__turbopack_context__.v({
  "close-button": "bPpGWq_close-button",
  "headline": "bPpGWq_headline",
  "section": "bPpGWq_section",
  "wrapper": "bPpGWq_wrapper",
});
